export default __webpack_public_path__ + "static/media/geo-spacial.9149f1df.png";